import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const ImageLeftCarContainer = styled.div`
  position: absolute;
  inset-block-end: -42px;
  inset-inline-start: -50px;

  display: none;

  ${theme.breakpoints.up("desktop")} {
    display: block;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    inset-inline-start: 0;
  }
`;

export const ImageRightCarContainer = styled.div`
  position: absolute;
  inset-block-end: -12px;
  inset-inline-start: 70%;

  display: none;

  ${theme.breakpoints.up("desktop")} {
    display: block;
  }
`;

export const ImageRightCarInTabletContainer = styled.div`
  position: absolute;
  inset-block-end: -79px;
  inset-inline-end: 3px;

  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }

  ${theme.breakpoints.up("desktop")} {
    display: none;
  }
`;

export const Container = styled.div`
  position: relative;
  z-index: 1;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;

  background-color: #fcf5de;
`;

export const Wrapper = styled.div`
  position: relative;

  display: flex;
  flex-flow: column;
  align-items: center;

  inline-size: 100%;
  max-inline-size: 1440px;
  padding-block-start: 61px;

  overflow: hidden;
  ${theme.breakpoints.up("tablet")} {
    padding-block: 30px 100px;
  }
  ${theme.breakpoints.up("desktop")} {
    padding-block: 30px 125px;
  }
`;
